import { Badge, Skeleton } from 'antd';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import React from 'react';

export const CalendarContainer = styled.div`
  background-color: #f5f5f5;
  border-radius: 2px;
`;

export const CalendarCellContainer = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-weight: bold;
`;

export const CalendarCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CalendarCellCircle = styled.span`
  background-color: ${({ taskColor }) => taskColor};
  width: 10px;
  height: 10px;
  border-radius: 50%;
`;

export const CalendarCellTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CalendarCellText = styled.span``;

export const Board = styled.div`
  width: 100%;
  overflow-x: visible; /* Changed from auto to visible to prevent independent scrolling */
  height: calc(100vh - 250px);
`;

export const Container = styled.div`
  display: flex;
  gap: 10px;
  width: fit-content;
  height: 100%;
`;

export const Column = styled.div`
  flex: 1;
  width: 280px;
  height: calc(100vh - 250px);
  display: flex;
  flex-direction: column;

  /* Ensure Ant Design Card takes full height */
  .ant-card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .ant-card-body {
    flex: 1;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
  }
`;

export const ExtraContainer = styled.div``;

export const ExtraBadge = styled(Badge).attrs({
  style: {
    backgroundColor: '#52c41a',
    color: '#fff',
    boxShadow: '0 0 0 1px #52c41a inset',
    marginRight: '3px',
  },
})``;

export const ExtraTotalBadge = styled(Badge).attrs({
  style: {
    backgroundColor: '#fff',
    color: '#999',
    boxShadow: '0 0 0 1px #d9d9d9 inset',
  },
})``;

export const ColumnContent = styled.div`
  padding: 8px;
  width: 100%;
  background-color: #f5f5f5;
  flex: 1;
  overflow-y: auto;
  
  /* Custom scrollbar styling */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const InfiniteScrollExtraContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

export const InfiniteScrollStyled = styled(InfiniteScroll)`
  height: 100% !important;
  
  .infinite-scroll-component__outerdiv {
    height: 100%;
  }
  
  .infinite-scroll-component {
    height: 100% !important;
    overflow-y: auto !important;
  }

  ::-webkit-scrollbar {
    height: 12px;
    width: 6px;
    background: #ddd;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #aaa;
  }
`;

export const LoadingSkeletonContainer = styled.div`
  margin: 0 0 8px 0;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  height: 80px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`;

export const SkeletonLine = styled.div`
  height: ${props => props.height || '12px'};
  width: ${props => props.width || '100%'};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonIcon = styled.div`
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 50%;
  animation: shimmer 1.5s infinite;
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const LoadingSkeleton = () => (
  <LoadingSkeletonContainer>
    <SkeletonHeader>
      <SkeletonLine height="14px" width="60%" />
      <SkeletonIcon />
    </SkeletonHeader>
    <div>
      <SkeletonLine height="10px" width="80%" style={{ marginBottom: '4px' }} />
      <SkeletonLine height="10px" width="50%" />
    </div>
  </LoadingSkeletonContainer>
);

export const ConfettiContainer = styled.div`
  position: fixed;
  z-index: 1000;
  inset: 0;
  pointer-events: none;
  
  canvas {
    pointer-events: none;
  }
`;